module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<label class=\"dropdown-label\">")
    ; __append(escapeFn( locals.label || 'Date Range' ))
    ; __append("</label> <div class=\"daterange-picker\"> <div> <input type=\"text\" class=\"form-control text-body-color border-0 p-0\" name=\"date_range\"> <span class=\"dropdown-toggle\"></span> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/datepicker_range.ejs
// module id = 1216
// module chunks = 1